import { getAvailableViews } from '@shared/auth/session';

/**
 * Switching between the Pro and Citizen views of one account.
 *
 * Both are hard navigations on purpose: the two views have different layouts,
 * themes and providers, and `accountType` is read during bootstrap. A client-side
 * route change would leave the previous shell mounted around the new view.
 *
 * Extracted from SelectViewPage so the profile-menu link and the chooser agree on
 * what switching means, rather than keeping two copies of "set accountType, then
 * navigate".
 */

/** True when this account can use both views, so a switch is meaningful. */
export function hasDualViewAccess(): boolean {
  const views = getAvailableViews();
  if (views.includes('citizen') && views.includes('professional')) return true;
  // availableViews is written only by setAuthSession from a login response, so
  // fall back to the flag login also records — a session that predates one of
  // the two should still be able to switch.
  return localStorage.getItem('hasDualAccess') === 'true';
}

export function switchToCitizenView(returnUrl?: string): void {
  localStorage.setItem('accountType', 'citizen');
  // /citizen/dashboard only redirects to /citizen/home; go straight there.
  window.location.href = returnUrl && returnUrl.startsWith('/citizen') ? returnUrl : '/citizen/home';
}

export function switchToProfessionalView(returnUrl?: string): void {
  localStorage.setItem('accountType', 'professional');
  window.location.href = returnUrl && !returnUrl.startsWith('/citizen') ? returnUrl : '/dashboard';
}
